// extracted by mini-css-extract-plugin
export default {"RBtn":"RBtn_RBtn__9z+WC"};